/**
 * Created by kgaar2 on 4/3/2017.
 */

import './builder-basic.scss';

var appData = {
    groups             : [],
    currentColor        : "#000000",
    counter             : 0,
    currentGroupCounter : 0,
    startColor          : "#f5f1e7",
    showNames           : false,
    pngHeight           : "1600",
    pngWidth            : "3000",
    labelColor          : "black"
};



    //Not done, review
    var mainSelectors = {
        addGroupButton  : $("#addGroup"),
        makeCodeButton  : $("#makeCode"),
        clearButton     : $("#clear"),
        showAllButton   : $("#showAll"),
        mapCode         : $("#mapCode"),
        downloadImage   : $("#downloadImage"),
        toggleNames     : $("#toggleNames"),
        countyColor     : $("#countyColor"),
        countyPattern   : $("#countyPattern"),
        countyIncluded  : $("#countyIncluded"),
        hexTextBox      : $("#hexText"),
        hexColorButton  : $("#hexButton")
    };

    //Review this function on integration with vue
    var clear = function(){
        //mainSelectors.countyColor.addClass("hide");
        //mainSelectors.countyPattern.addClass("hide");
        //mainSelectors.countyIncluded.addClass("hide");
        $("#currentGroup").addClass("hide");
        appData.groups = [];
        showAll();
        $("#countyGroups").empty();
        appData.currentGroupCounter = 0;
        appData.counter = 0;
        //$("#setName").text("");
        $("#contains").text("");
        mainSelectors.countyColor.css("background","");
    };

    var showAll = function(){

        /*if($("#legend").length){
            makeMap.clearLegend();
            console.log("test");
        }*/

        makeMap.patternFillCounty("none");
        makeMap.colorCounty();

        for(var x=0;x<appData.groups.length;x++){
            //var countySet = makeMap.addLegend(appData.groups[x].color, "Group "+(x+1), appData.groups[x].pattern);
            //makeMap.patternFillCounty(countySet, appData.groups[x].counties);
            makeMap.patternFillCounty(appData.groups[x].pattern, appData.groups[x].color, appData.groups[x].counties);
        }
    };

    var changeGroupColor = function(name, color){
        appData.groups[parseInt(name.substr(name.length - 1, 1)) - 1].color = color;
        $("#" + name).css("background", color);
        showAll();
    };

    var changeGroupPattern = function(name, pattern){
        appData.groups[parseInt(name.substr(name.length - 1, 1)) - 1].pattern = pattern;
        //$("#" + name).css("background", color);
        showAll();
    };

    var addLabels = function() {
        $("#nebraska #fieldNameText").remove();

        $("#nebraska").find(".county").each(function(i, obj) {
            var $cur = $(obj);

            makeMap.addMapLabel(parseFloat($cur.find(".fill-color").attr("x")) + parseFloat($cur.find(".fill-color").attr("width")) / 2, parseFloat($cur.find(".fill-color").attr("y")) +  parseFloat($cur.find(".fill-color").attr("height"))/2 , $cur.find(".stroke")[0].getAttribute("data-countyName"), {
                "fontSize": "6px",
                "fontFamily": "Verdana"
            });
        });

        $("#nebraska #fieldNameText")
            .toggleClass("hide")
            .addClass("unclickable")
            .find("text")
            .attr("fill", appData.labelColor);
    };

    var makeMap = new neMap.init("#nebraska");

    makeMap.events.click = function (obj, id, county){

        var includesId = function(array, id){
            for(var i = 0; i < array.length; i++){
                if(array[i] == id){
                    return true;
                }
            }
            return false;
        }

        //Checks if there are any groupings of counties to add this county to
        if(appData.groups.length > 0){

            if(includesId(appData.groups[appData.currentGroupCounter].counties, id)){
                var index = appData.groups[appData.currentGroupCounter].counties.indexOf(id);
                appData.groups[appData.currentGroupCounter].counties.splice(index, 1);
                makeMap.patternFillCounty("none", "#8f8f8f", id);
            } else {

                //Loops through all county groups to locate the selected county.
                //If found, it removes it from the found group and adds it to the selected group
                for(var i = 0; i < appData.groups.length; i++){
                    if(includesId(appData.groups[i].counties, id)){
                        var index = appData.groups[i].counties.indexOf(id);
                        appData.groups[i].counties.splice(index, 1);
                    }
                }
                appData.groups[appData.currentGroupCounter].counties.push(id);
                makeMap.patternFillCounty(appData.groups[appData.currentGroupCounter].pattern, appData.groups[appData.currentGroupCounter].color, id);
            }
            appData.groups[appData.currentGroupCounter].counties.sort(function(a,b){return a-b;});
            $("#contains").text(appData.groups[appData.currentGroupCounter].counties);
        }

        showAll();
    };

    mainSelectors.addGroupButton.on("click", function(){
        $("#currentGroup").removeClass("hide");

        appData.groups.push({
            "name": "Group "+(appData.counter + 1),
            "counties": [],
            "color": appData.startColor,
            "pattern":"none"
        });

        var currentGroup = ""+appData.counter;

        var groupClick = function(button){

            $(button)
                .addClass("groupSelected")
                .siblings().removeClass("groupSelected");;

            appData.currentGroupCounter = parseInt(currentGroup);
            //$("#setName").text(appData.groups[parseInt(string)].name);
            $("#contains").text(appData.groups[parseInt(currentGroup)].counties);


            $("#countyColor .color").each(function(){
                $(this).css("background-color", $(this).attr("data-color") );
            });

            $("#countyColor .color").off("click");

            $("#countyColor .color").click(function(){
                $(this).addClass("selected").siblings().removeClass("selected");
                var thisColor = $(this).attr("data-color");
                changeGroupColor("group"+(parseInt(currentGroup) + 1), thisColor);
                if($(this).hasClass("darkText")){
                    $(button).addClass("darkText");
                } else {
                    $(button).removeClass("darkText");
                }
                mainSelectors.hexTextBox.val(""+appData.groups[parseInt(currentGroup)].color);
            });

            $("#countyColor .color").each(function(){
                if($(this).attr("data-color") ==  appData.groups[parseInt(currentGroup)].color){
                    $(this).addClass("selected");
                } else {
                    $(this).removeClass("selected");
                }
            });

            mainSelectors.hexTextBox.val(""+appData.groups[parseInt(currentGroup)].color);

            mainSelectors.hexColorButton.off("click");

            mainSelectors.hexColorButton.on("click", function(){
                var colorText = mainSelectors.hexTextBox.val();
                var red, blue, green, filter;

                if(colorText.length == 6) {
                    colorText = "#"+colorText;
                }


                if(/^#[0-9A-F]{6}$/i.test(colorText)){

                    //Logic to decide between light and dark text
                    red = parseInt(colorText.substr(1,2),16);
                    green = parseInt(colorText.substr(3,2),16);
                    blue = parseInt(colorText.substr(5,2),16);
                    filter = (red*0.299 + green*0.587 + blue*0.114);

                    changeGroupColor("group"+(parseInt(currentGroup) + 1), colorText);

                    if(filter > 186){
                        $(button).addClass("darkText");
                    } else {
                        $(button).removeClass("darkText");
                    }

                    $("#countyColor .color").removeClass("selected");
                }


            });

            $("#countyPattern .pattern").off("click");

            $("#countyPattern .pattern").click(function(){
                $(this).addClass("selected").siblings().removeClass("selected");
                var thisPattern = $(this).attr("data-pattern");
                changeGroupPattern("group"+(parseInt(currentGroup) + 1), thisPattern);
            });

            $("#countyPattern .pattern").each(function(){
                if($(this).attr("data-pattern") == appData.groups[parseInt(currentGroup)].pattern){
                    $(this).addClass("selected").siblings().removeClass("selected");
                }
            });


        };

        var $groupButton = $("<a id='group" + (appData.counter + 1) + "' class='mapGroupingButton wdn-button'>Group "+ (appData.counter + 1) + "</a>")
            .css("background", appData.startColor)
            .addClass("darkText");

        $("#countyGroups").append($groupButton);

        //$groupButton.siblings().removeClass("groupSelected");
        //$groupButton.addClass("groupSelected");

        var identifier = "#group"+(appData.counter + 1);

        $("#group"+(appData.counter + 1)).on("click", function(){
            groupClick(identifier);
        });

        groupClick(identifier);

        showAll();
        appData.counter++;
    });


    //Creates a string with html/javascript code to create desired map
    var makeCode = function(mapId, mapVariableName,colorGroups, clickFunction, mouseOverFunction, mouseOutFunction, extrastring, extraCode){

        var mapString = "<div id='"+mapId+"'></div>\n"
        var clickFunctionString, mouseOverFunctionString, mouseOutFunctionString, extraCodeString;
        if(typeof clickFunction === "function"){
            clickFunctionString = mapVariableName+".events.click =" + clickFunction;
        } else {
            clickFunctionString = "";
        }
        if(typeof mouseOverFunction === "function"){
            mouseOverFunctionString = mapVariableName+".events.mouseOver =" +mouseOverFunction;
        } else {
            mouseOverFunctionString = "";
        }
        if(typeof mouseOutFunction === "function"){
            mouseOutFunctionString = mapVariableName+".events.mouseOut =" +mouseOutFunction;
        } else {
            mouseOutFunctionString = "";
        }
        if(typeof extraCode === "function"){
            extraCodeString = mapVariableName+".events.mouseOver =" +extraCode;
        } else {
            extraCodeString = "";
        }
        if(typeof extrastring === "string") {
            mapString = mapString + extrastring;
        }

        mapString = mapString +
            "<script>\n" +
            "document.addEventListener('DOMContentLoaded', function(event){\n" +
            "\trequire(['"+neMap_ScriptBase + "/neMap.js" +"', 'jquery'], function(map, $) { \n" +
            "\t\tvar "+mapVariableName+" = new neMap.init('#"+mapId+"');\n" +
            "\t\tvar groups = "+ JSON.stringify(colorGroups)+"; \n" +
            "\t\tfor(var x=0;x<groups.length;x++){\n" +
            "\t\t\t"+mapVariableName+".patternFillCounty(groups[x].pattern, groups[x].color , groups[x].counties); \n" +
            "\t\t}\n" +
            "\t\t" + clickFunctionString +"\n"+
            "\t\t" + mouseOverFunctionString +"\n"+
            "\t\t" + mouseOutFunctionString +"\n"+
            "\t\t" + extraCodeString +"\n"+
            "\t});\n" +
            "});\n" +
            "</script>\n";
        return mapString;
    };

    mainSelectors.makeCodeButton.on("click", function(){

        ga("send", "event", "Code Made", "Basic Map", "");

        //Function to apply names to generated map html
        var a = function() {
            $("#map").find(".county").each(function(i, obj) {
                var $cur = $(obj);

                madeMap.addMapLabel(parseFloat($cur.find(".fill-color").attr("x")) + parseFloat($cur.find(".fill-color").attr("width")) / 2, parseFloat($cur.find(".fill-color").attr("y")) +  parseFloat($cur.find(".fill-color").attr("height"))/2 , $cur.find(".stroke")[0].getAttribute("data-countyName"), {
                    "fontSize": "6px",
                    "fontFamily": "Verdana",
                });

            });
            $("#nebraska #fieldNameText").toggleClass("hide");
        };

        var mapCode;

        var styleString = "";
        mapCode = makeCode("map", "madeMap", appData.groups);

        var $code = $("<pre class='prettyprint'></pre>");
        $code.text(mapCode);
        $('#mapCode').html($code);
    });
    mainSelectors.clearButton.on("click", clear);

    //Sends a request to server-side page in order to convert map svg to png
    $("#downloadImageSmall").click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        appData.pngHeight = 500;
        appData.pngWidth = 1000;

        imageDownloadRequest();
    });

    $("#downloadImageMedium").click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        appData.pngHeight = 1500;
        appData.pngWidth = 3000;

        imageDownloadRequest();
    });

    $("#downloadImageLarge").click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        appData.pngHeight = 3000;
        appData.pngWidth = 6000;

        imageDownloadRequest();
    });

    var imageDownloadRequest = function(){

        //Sends download event to google analytics
        ga("send", "event", "Download Image", "Basic Map", "Height = " + appData.pngHeight + ", Width = " + appData.pngWidth);

        var $svg = $("#nebraska").find("svg").clone();

        //This changes the dimensions of the cloned svg in order to change the dimensions of the picture
        $svg
            .attr("height", appData.pngHeight)
            .attr("width", appData.pngWidth);

        $svg[0].setAttribute("viewBox", "150 0 820 600");
        $svg[0].setAttribute("preserveAspectRatio", "xMidYMid meet");

        $svg.find("#fieldNameText rect")
            .css("fill", "none")
            .css("stroke-width", "0");

        if(!appData.namesShow){
            $svg.find("#fieldNameText")
                .css("display", "none");
        }

        var $form = $("#imageDownloadForm");
        $form.find("#iconText").val($svg.prop("outerHTML"));
        $form.find("#iconTitle").val("MapPicture");
        $form.find("#outputFormat").val("PNG");

        $form.submit();
    };

    mainSelectors.toggleNames.click(function(e){
        $("#nebraska #fieldNameText").toggleClass("hide");
        appData.namesShow = !appData.namesShow;
    });


    //Initialize the components
    clear();

